import { Injectable } from '@angular/core';
import { CurrentCompanyFacade } from '@app/modules/zones/facade/current-company.facade';
import { Asset } from '@app/modules/location-client/location-api.models';
import { BehaviorSubject, merge, distinctUntilKeyChanged, filter, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store';
import { selectAssetCount, selectAssetsLoadError } from '@app/store/asset/selectors/assets.selectors';
import { selectAssetsLoadState } from '@app/store/asset/selectors/assets.selectors';

@Injectable({
  providedIn: 'root'
})

// a facade service that gets various info in NGRX state to pass to LeafletZonesService to determine when we render zones
export class DataForZones {
  constructor(private currentCompanyFacade: CurrentCompanyFacade, private store: Store<AppState>) {}

  selectedAsset$: BehaviorSubject<Asset> = new BehaviorSubject(null);

  getCurrentCompanyId() {
    return merge(
      // get the company id from list view
      this.currentCompanyFacade.getCurrentCompanyId(),

      // get the company id when loading asset history or asset live details view first
      this.selectedAsset$.pipe(
        filter(asset => Boolean(asset?.companyId)),
        distinctUntilKeyChanged('companyId'),
        map(asset => asset.companyId)
      )
    );
  }

  getAssetsLoadState() {
    return this.store.select(selectAssetsLoadState);
  }
}
